import { getBuyerId } from 'dibs-cookie-jar';
import { hasSeenCallout, saveToStorage } from './favoritesCalloutHelpers';

const CALLOUT_TYPES = {
    EDIT_FOLDER: 'editFolder',
    REARRANGE_ITEMS: 'rearrangeItems',
};

export function favoritesEditFolderRule() {
    const userId = getBuyerId(document.cookie);
    const hasSeen = hasSeenCallout(CALLOUT_TYPES.EDIT_FOLDER);
    const showCallout = !!userId && !hasSeen;
    if (showCallout) {
        saveToStorage({ type: CALLOUT_TYPES.EDIT_FOLDER });
    }
    return Promise.resolve(showCallout);
}

export function favoritesRearrangeItemsRule() {
    const userId = getBuyerId(document.cookie);
    const hasSeen = hasSeenCallout(CALLOUT_TYPES.REARRANGE_ITEMS);
    const showCallout = !!userId && !hasSeen;
    if (showCallout) {
        saveToStorage({ type: CALLOUT_TYPES.REARRANGE_ITEMS });
    }
    return Promise.resolve(showCallout);
}
